import { useResourceList__ALPHA } from '@cube3/state/src/redux/components/Hooks/useResourceList';
import { actionCreators } from '@cube3/state/src/redux/ducks/request-status';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

const debug = false;
/**
 * Return approvals filtered by review link
 * @param nodeId
 * @param reviewLinkId
 * @param withPolling : defaults to false, if true will poll approvals every 5 seconds
 * @returns
 */
export const useReviewApprovals = (
  nodeId: string,
  reviewLinkId: string,
  withPolling = false
) => {
  /**  In review link view: it only returns the approvals created by the current reviewer
   * -  Do we want to see the approvals created by other users?
   */
  const approvals = useResourceList__ALPHA({
    resourceType: 'content-tree-node',
    resourceId: nodeId,
    edgeType: 'approval',
    edgeLabel: 'approvals',
    params: useMemo(
      () => ({
        filter: {
          share: reviewLinkId
        }
      }),
      [reviewLinkId]
    )
  });

  /** overall rating */
  const rejected =
    approvals.resources?.length &&
    approvals.resources.findIndex((a) => a.status === 'rejected') > -1;

  /** overall rating */
  const approved =
    approvals.resources?.length &&
    approvals.resources.every((a) => a.status === 'approved');

  // perform some polling on the approval status to prevent conflicts when multiple recipients modify status at same time
  const [polling, setPolling] = useState(0);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!nodeId || !withPolling || debug) return;
    const timer = setTimeout(() => {
      dispatch(
        actionCreators.invalidateRelationship({
          type: 'content-tree-node',
          id: nodeId,
          relationship: 'approvals'
        })
      );
      setPolling((prev) => prev + 1);
    }, 10000);
    return () => clearTimeout(timer);
  }, [nodeId, dispatch, withPolling, polling]);

  return { approvals, approved, rejected };
};
